<template>
    <p>
        <!-- eslint-disable vue/no-v-html -->
        <span
            ref="content"
            v-resize.immediate="setContentOverflowing"
            :class="[
                `break-text whitespace-pre-wrap ${contentAppearance}`,
                isCollapsed ? `line-clamp-[var(--nb-lines)]` : 'line-clamp-none',
            ]"
            :style="{ '--nb-lines': maxLines }"
            v-html="content ? linkify(htmlEncode(unlinkify(content)), {}) : ''"
        ></span>
        <!-- eslint-enable -->

        <span
            v-if="isContentOverflowing || !isCollapsed"
            :class="['cursor-pointer', showMoreAppearance]"
            @click="toggle"
            v-text="isCollapsed ? $t('showMore') : $t('showLess')"
        ></span>
    </p>
</template>

<script>
import { linkify, unlinkify } from '@helpers/linkify';
import { htmlEncode } from '@helpers/string';

export default {
    name: 'CollapsibleText',
    props: {
        content: {
            type: String,
            required: true,
        },
        maxLines: {
            type: Number,
            required: false,
            default: 5,
        },
        showMoreAppearance: {
            type: String,
            required: false,
            default: 'font-medium text-slate-600 text-sm',
        },
        contentAppearance: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            isCollapsed: true,
            isContentOverflowing: false,
        };
    },
    methods: {
        linkify,
        unlinkify,
        htmlEncode,
        async toggle() {
            this.isCollapsed = !this.isCollapsed;

            // this prevents big texts of getting out of the view when they are collapsed
            if (this.isCollapsed === true) {
                await this.$nextTick();

                this.$refs.content.scrollIntoView({
                    behavior: 'auto',
                    block: 'center',
                });
            }
        },
        async setContentOverflowing(target) {
            // when the element is collapsed the height of its overflowed
            // content is greater than the element height itself
            this.isContentOverflowing = target.scrollHeight > target.offsetHeight;
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.break-text) {
    word-break: break-word !important;
}
</style>
